import { Descriptions, Spin, Typography } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { match as routerMatch } from 'react-router-dom';
import { Dispatch } from 'redux';
import IUser from '~Api/User/IUser';
import { IGlobalState } from '~reducer';
import { userGetAction } from '~Users/actions';
import { userSelector } from '~Users/selectors';
import Layout from './Layout';

interface IMatch {
    uuid: string;
}

interface IProps {
    match: routerMatch<IMatch>;
}

interface IPropsSelector {
    user: IUser;
}

interface IPropsDispatch {
    userGet: () => void;
}

type Props = IProps & IPropsSelector & IPropsDispatch;

class Overview extends React.Component<Props> {
    public componentDidMount() {
        const { user } = this.props;

        if (!user) {
            this.props.userGet();
        }
    }

    public render(): JSX.Element {
        const { match, user } = this.props;

        if (!user) {
            return (
                <Layout uuid={match.params.uuid} section='overview'>
                    <Typography.Title level={2}>Overview</Typography.Title>
                    <Spin/>
                </Layout>
            );
        }

        return (
            <Layout uuid={match.params.uuid} section='overview'>
                <Typography.Title level={2}>Overview</Typography.Title>
                <Descriptions>
                    <Descriptions.Item label='Created'>{user.createdTime ? dayjs(user.createdTime).format('Do MMMM YYYY HH:mm:ss') : '-'}</Descriptions.Item>
                </Descriptions>
            </Layout>
        );
    }
}

function mapStateToProps(state: IGlobalState, ownProps: IProps): IPropsSelector {
    return {
        user: userSelector(state, ownProps.match.params.uuid),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        userGet: () => dispatch(userGetAction(ownProps.match.params.uuid)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Overview);
